import moment from 'moment'
import momentTz from 'moment-timezone'

export const USER_DEVICE_ZONE = Object.freeze(momentTz.tz.guess()) // return time zone name of current device

const deviceTz = moment().tz(USER_DEVICE_ZONE).utcOffset() / 60

export const autoDeviceTimeZone = deviceTz >= 0 ? `+${deviceTz}` : `${deviceTz}`
